import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import RequiredLabel from "../RequiredLabel";

const Steps2 = ({
  count,
  setCount,
  detailsSet,
  details,
  initialData,
  completeCurrentStep,
}) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || "",
    first_name: initialData?.first_name || "",
    father_name: initialData?.second_name || "", // Assuming 'second_name' maps to father/husband
    last_name: initialData?.last_name || "",
    dob: initialData?.birth_date || "", // Assuming 'birth_date' maps to dob
    birth_place: initialData?.birth_place || "",
    native_place: initialData?.native_place || "",
    nationality: initialData?.nationality || "",
    mother_tongue: initialData?.mother_tongue || "",
    gender: initialData?.gender || "",
    blood_group: initialData?.blood_group || "",
    marital_status: initialData?.marital_status || "",
    any_disability: initialData?.disability === "1" ? true : false || false,
    disability_explain: initialData?.disabilitydetail || "",
  });

  const initialErrorData = {
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    blood_group: "",
    marital_status: "",
  };

  const [errors, setErrors] = useState(initialErrorData);

  var userMemberId = localStorage.getItem("aimsUserMemberId");
  useEffect(() => {
    setFormData(details);
  }, [details]);
  // useEffect(() => {
  //   // Update formData when initialData changes (API data is loaded)
  //   if (initialData) {
  //     setFormData({
  //       title: initialData.title || "",
  //       first_name: initialData.first_name || "",
  //       father_name: initialData.second_name || "", // Assuming 'second_name' in API maps to father/husband name
  //       last_name: initialData.last_name || "",
  //       dob: initialData.birth_date || "", // Assuming 'birth_date' in API maps to dob
  //       birth_place: initialData.birth_place || "",
  //       native_place: initialData.native_place || "",
  //       nationality: initialData.nationality || "india", // Default if not present
  //       mother_tongue: initialData.mother_tongue || "hindi", // Default if not present
  //       gender: initialData.gender || "",
  //       blood_group: initialData.blood_group || "",
  //       marital_status: initialData.marital_status || "Single", // Default if not present
  //       any_disability: initialData.disability === "1" ? true : false || false, // Assuming '1' means true
  //       disability_explain: initialData.disabilitydetail || "",
  //     });
  //   }
  // }, [initialData]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name) {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });

      if (value?.trim() !== "") {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      }
    }
  };

  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    if (!formData.first_name || formData.first_name.trim() === "") {
      newErrors.first_name = "Please enter your First Name";
      isValid = false;
    }

    if (!formData.last_name || formData.last_name.trim() === "") {
      newErrors.last_name = "Please enter your Last Name";
      isValid = false;
    }

    if (!formData.dob || formData.dob.trim() === "") {
      newErrors.dob = "Please enter your Date of Birth";
      isValid = false;
    }

    if (!formData.gender || formData.gender.trim() === "") {
      newErrors.gender = "Please select your Gender";
      isValid = false;
    }

    if (!formData.blood_group || formData.blood_group.trim() === "") {
      newErrors.blood_group = "Please select your Blood Group";
      isValid = false;
    }

    if (!formData.marital_status || formData.marital_status.trim() === "") {
      newErrors.marital_status = "Please select your Marital Status";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const transformData = (data) => {
    return {
      basic_details: {
        title: data.title || "",
        first_name: data.first_name || "",
        father_name: data.father_name || "",
        last_name: data.last_name || "",
        dob: data.dob || "",
        birth_place: data.birth_place || "",
        native_place: data.native_place || "",
        nationality: data.nationality || "",
        mother_tongue: data.mother_tongue || "",
        gender: data.gender || "",
        blood_group: data.blood_group || "",
        marital_status: data.marital_status || "",
        any_disability: data.any_disability ? true : false,
        disability_explain: data.disability_explain || "",
      },
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formattedData = transformData(formData);
      detailsSet(formData);
      sendBasicDetails(formattedData);
    }
  };

  const sendBasicDetails = (el) => {
    axios
      .post(
        `https://anoopam.com/aims/api/?action=basicdetails&memberid=${userMemberId}`,
        { ...el }
      )
      .then((res) => {
        if (res?.data?.status === "success") {
          Swal.fire({
            text: `${res?.data?.msg}`,
            icon: "success",
          });
          setCount(count + 1);
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.response?.data?.message || "An error occurred"}`, // Handle potential lack of data in error
          icon: "error",
        });
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-5 p-4 border main rounded-4  bg-white">
        <div className="row  ">
          <div className="col-lg-2">
            <label className="tittle-text" htmlFor="name">
              Title
            </label>
            <select
              className={`form-select mt-2 bg-white ${
                formData.title ? "bg-green-100" : "bg-white"
              }`}
              name="title"
              value={formData.title}
              onChange={handleInputChange}
            >
              <option value="">Select Title</option>
              <option value="Mr."> Mr </option>
              <option value="Mrs."> Mrs </option>
              <option value="Ms."> Ms </option>
              <option value="Dr."> Dr </option>
              <option value="Shri."> Shri </option>
              <option value="Smt."> Smt </option>
            </select>
          </div>

          <div className="col-lg-3 ">
            <label className="tittle-text " htmlFor="name">
              {" "}
              <RequiredLabel htmlFor="firstname">First Name</RequiredLabel>
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              placeholder="Enter First Name"
              className={`form-control mt-2 ${
                errors?.first_name ? "is-invalid" : ""
              }`}
            />
            {errors?.first_name && (
              <span className="text-danger fw-medium  d-inline-flex">
                {errors?.first_name}
              </span>
            )}
          </div>
          <div className="col-lg-3">
            <label className="tittle-text" htmlFor="name">
              Father/Husband Name
            </label>
            <input
              type="text"
              placeholder="Enter Father/Husband Name"
              className="form-control mt-2 "
              name="father_name"
              value={formData.father_name}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-lg-3">
            <RequiredLabel htmlFor="name">Last Name</RequiredLabel>
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              className={`form-control mt-2 ${
                errors?.last_name ? "is-invalid" : ""
              }`}
              placeholder=" Enter Last name"
            />
            {errors?.last_name && (
              <span className="text-danger fw-medium  d-inline-flex">
                {errors?.last_name}
              </span>
            )}
          </div>

          {/* second row  */}
          <div className="col-lg-2 mt-3 ">
            <RequiredLabel htmlFor="dob">Date of Birth</RequiredLabel>
            <input
              type="date"
              id="dob"
              name="dob"
              className={`form-control  mt-2 ${
                errors?.dob ? "is-invalid" : ""
              }`}
              placeholder="Select Date"
              value={formData.dob}
              onChange={handleInputChange}
            />
            {errors?.dob && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.dob}
              </span>
            )}
          </div>

          <div className="col-lg-2 mt-3">
            <label className="tittle-text" htmlFor="name">
              Place of Birth
            </label>
            <input
              type="text"
              id="birth_place"
              name="birth_place"
              placeholder="Enter Place of Birth"
              className="form-control  mt-2"
              value={formData.birth_place}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-lg-2 mt-3">
            <label className="tittle-text" htmlFor="name mt-2">
              Native Place
            </label>
            <input
              type="text"
              id="native_place"
              name="native_place"
              placeholder="Enter Native Place"
              className="form-control  mt-2"
              value={formData.native_place}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-lg-2 mt-3">
            <label className="tittle-text" htmlFor="name mt-3">
              Nationality
            </label>
            <select
              className="form-select mt-2"
              aria-label="Default select example  "
              name="Nationality"
              value={formData.nationality}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="india">India</option>
              <option value="america">America</option>
              <option value="nepal">Nepal</option>
            </select>
          </div>

          <div className="col-lg-3 mt-3">
            <label className="tittle-text" htmlFor="name">
              Mother Tongue
            </label>
            <select
              className="form-select mt-2"
              aria-label="Default select example "
              name="mother_tongue"
              value={formData.mother_tongue}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="hindi">Hindi</option>
              <option value="gujarati">Gujarati</option>
              <option value="english">English</option>
            </select>
          </div>

          {/* genders  */}
          <div className="col-11 mt-3">
            <RequiredLabel htmlFor={"gendert"}> Gender</RequiredLabel>
            <div className="d-flex gap-3 flex-wrap mt-2">
              {["Male", "Female", "Other"].map((gender, index) => (
                <React.Fragment key={index}>
                  <input
                    hidden
                    name="gender"
                    id={`gender-${index}`}
                    type="radio"
                    value={gender}
                    checked={formData.gender === gender}
                    onChange={handleInputChange}
                  />
                  <label
                    htmlFor={`gender-${index}`}
                    className={`btn rounded-5 button1 ${
                      formData.gender === gender ? "active" : ""
                    }`}
                  >
                    {gender}
                  </label>
                </React.Fragment>
              ))}
            </div>
            {errors?.gender && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.gender}
              </span>
            )}
          </div>

          {/* blood group */}
          <div className="col-11 mt-3">
            <RequiredLabel htmlFor={"bloof group"}> Blood Group</RequiredLabel>
            <div className="d-flex gap-3 flex-wrap mt-2">
              {["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"].map(
                (group, index) => (
                  <React.Fragment key={index}>
                    <input
                      hidden
                      type="radio"
                      name="blood_group"
                      value={group}
                      id={`blood_group-${index}`}
                      checked={formData.blood_group === group}
                      onChange={handleInputChange}
                    />
                    <label
                      htmlFor={`blood_group-${index}`}
                      className={`btn rounded-5 button1 ${
                        formData.blood_group === group ? "active" : ""
                      }`}
                    >
                      {group}
                    </label>
                  </React.Fragment>
                )
              )}
            </div>
            {errors?.blood_group && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.blood_group}
              </span>
            )}
          </div>

          {/* Status  */}
          <div className="col-11 mt-3">
            <RequiredLabel htmlFor={"marital status"}>
              {" "}
              Marital Status
            </RequiredLabel>
            <div className="d-flex gap-3 flex-wrap mt-2">
              {["Single", "Married", "Other"].map((status, index) => (
                <React.Fragment key={index}>
                  <input
                    hidden
                    type="radio"
                    name="marital_status"
                    value={status}
                    id={`marital_status-${index}`}
                    checked={formData.marital_status === status}
                    onChange={handleInputChange}
                  />
                  <label
                    htmlFor={`marital_status-${index}`}
                    className={`btn rounded-5 button1 ${
                      formData.marital_status === status ? "active" : ""
                    }`}
                  >
                    {status}
                  </label>
                </React.Fragment>
              ))}
            </div>
            {errors?.marital_status && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.marital_status}
              </span>
            )}
          </div>

          {/* Disability  */}
          <div className="col-11 mt-4 ">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                className="form-check-input"
                id="any_disability"
                name="any_disability"
                checked={formData.any_disability}
                onChange={handleInputChange}
              />
              <label className="mx-2   tittle-text" htmlFor="any_disability">
                Any Disability?
              </label>
            </div>

            {formData?.any_disability && (
              <div className="col-12 mt-3">
                <label className="tittle-text" htmlFor="disability_explain">
                  Explain Disability
                </label>
                <div></div>
                <div className="form-floating col-12 mt-2">
                  <textarea
                    className="form-control"
                    placeholder="Leave a comment here"
                    id="disability_explain"
                    name="disability_explain"
                    value={formData.disability_explain}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 1 && ( // Changed count !== 0 to count !== 1 as step 1 has count 1
          <button
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 6 && ( // Changed count < 5 to count < 6 as you have 6 steps
          <button type="submit" className="rounded-5 btnBlue">
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps2;
